module.exports = __webpack_public_path__ + "img/2026-10-11a_2.12b2ec1d.jpg";